var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridiconsDropdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69992 5.71387C3.80902 5.71387 3.36285 6.79101 3.99281 7.42097L7.29288 10.721C7.68341 11.1116 8.31657 11.1116 8.7071 10.721L12.0072 7.42097C12.6371 6.79101 12.191 5.71387 11.3001 5.71387H4.69992Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridiconsDropdown);
export default __webpack_public_path__ + "static/media/gridicons_dropdown.8bdc90fac6ce46960b5ea9925978c732.svg";
export { ForwardRef as ReactComponent };